import { FC } from 'react';

import { Typography } from '../../../designComponents';
import { OurStrengthCountsStyled } from './style';
type OurStrengthCountsProps = {
  count: string;
  label: string;
  desc: string;
};
const OurStrengthCounts: FC<OurStrengthCountsProps> = ({
  count,
  desc,
  label,
}) => {
  return (
    <OurStrengthCountsStyled>
      <div className="main-counts">
        <Typography
          variant="heading"
          strong
          style={{ color: '#427AB2' }}
          className="counts"
        >
          {count || '2k +'}
        </Typography>
        <Typography fontColor="dark" variant="title">
          {label || 'Total Users'}
        </Typography>
      </div>
      <Typography>
        {desc || 'EscapePlan serves a diverse clientele of over 200 users'}
      </Typography>
    </OurStrengthCountsStyled>
  );
};

export default OurStrengthCounts;
